import AdminBar from 'js/admin_bar/AdminBarActivator';
import ArticleToolbar from 'js/journals/article/ArticleToolbar';
import DownloadButton from 'js/journals/article/DownloadButton';
import PodcastPlayer from 'js/journals/article/PodcastPlayer';
import SelectionCitation from 'js/journals/article/SelectionCitation';
import { CitationButton } from 'js/journals/CitationButton';
import { ShareButton } from 'js/journals/ShareButton';
import JournalNavbar from 'js/journals/JournalNavbar';
import { trackCWV } from 'js/utils/trackCWV';
import registerForRails from 'js/utils/registerForRails';
import LoggedOutBucketingBar from 'js/logged_out_bucketing_bar/LoggedOutBucketingBar';
import { trackClick } from 'js/utils/trackClick';
import * as Dismissibles from 'js/utils/dismissibles';
import * as User from 'js/utils/user';
import assignGlobal from 'js/utils/assign_global';
import { Kale } from 'js/core_webpack/metrics/kale';
import { loadRecordHit } from 'js/utils/loadRecordHit';
import { startActivityTracking } from 'js/core_webpack/metrics/page_activity_tracking';
import { captureException } from '@sentry/browser';
import { AiTranslationDropdown } from 'js/journals/article/AiTranslationDropdown';
import { ExpandableTable } from 'js/journals/article/ExpandableTable';
import FigureCarousel from 'js/journals/article/FigureCarousel';
import { trackArticleEngagement } from 'js/journals/article/articleEngagement';
import { trackQuickEvaluationLayoutExperiment } from 'js/journals/article/quickEvaluationLayoutExperiment';
import { trackArticleSections } from 'js/journals/article/articleSections';
import {
  ArticleCitation,
  CitationCountInfo,
} from 'js/journals/article/QuickEvaluationLayoutActions';

assignGlobal('Aedu', { trackClick });
assignGlobal('Aedu', { Dismissibles, User });
assignGlobal('Kale', Kale);

trackCWV();
startActivityTracking();
void loadRecordHit().catch(captureException);
trackArticleSections();
registerForRails({
  ArticleCitation,
  CitationCountInfo,
  LoggedOutBucketingBar,
  AdminBar,
  ArticleToolbar,
  DownloadButton,
  JournalNavbar,
  CitationButton,
  ShareButton,
  PodcastPlayer,
  AiTranslationDropdown,
  ExpandableTable,
  FigureCarousel,
  SelectionCitation,
});
trackQuickEvaluationLayoutExperiment();
trackArticleEngagement();

window.addEventListener('load', () => {
  const params = new URLSearchParams(window.location.search);

  const triggerDownload = (sourceParam: string) => {
    const downloadButton = document.querySelector(
      '.article-attachment-download-button',
    );
    if (downloadButton instanceof HTMLAnchorElement) {
      const [downloadUrl, downloadUrlParams] = downloadButton.href.split('?');
      const downloadParams = new URLSearchParams(downloadUrlParams);
      downloadParams.set('s', sourceParam);
      window.location.href = `${downloadUrl}?${downloadParams.toString()}`;
    }
  };

  // Map URL parameters to their corresponding source values
  const downloadSources = {
    email_action: 'email',
    article_card: 'article-card',
  } as const;

  // Handle all download cases in a single loop
  Object.entries(downloadSources).forEach(([param, source]) => {
    if (params.get(param) === 'download') {
      triggerDownload(source);
    }
  });
});
